import {
  AGENTCORE_NAMES,
  ASK_TEAMFORM_MODES,
  isAskTeamformV2Agent,
} from "./consts";

const HELP_PROMPTS = [
  "How do I import tags into TeamForm?",
  "How do I configure single sign-on?",
  "How does reporting with Redash work?",
  "What is the difference between supply and demand teams?",
  "How do I use Planner?",
];

/**
 * @param {object} options
 * @param {string} [options.askTeamformMode]
 * @param {boolean} [options.enableSupportQuestionInAskTeamform]
 * @param {string} [options.selectedAgent]
 * @param {object|null} [options.person]
 * @returns {string[]}
 */
export function getSuggestedPrompts({
  askTeamformMode = ASK_TEAMFORM_MODES.DATA,
  enableSupportQuestionInAskTeamform = false,
  selectedAgent = AGENTCORE_NAMES.ASK_TEAMFORM,
  person = null,
}) {
  const useModePrompts =
    enableSupportQuestionInAskTeamform && isAskTeamformV2Agent(selectedAgent);

  if (useModePrompts && askTeamformMode === ASK_TEAMFORM_MODES.SUPPORT) {
    return HELP_PROMPTS.slice(0, 4);
  }

  const workspacePrompts = [];

  if (person?.memberOf?.length > 0) {
    workspacePrompts.push("What are my team objectives?");
    workspacePrompts.push(
      "Build a comprehensive dashboard of the teams I am in"
    );
  }

  workspacePrompts.push("How are we tracking against our Principles?");

  if (workspacePrompts.length < 2) {
    workspacePrompts.push("How many people do we have?");
  }

  if (useModePrompts) {
    return workspacePrompts.slice(0, 4);
  }

  return workspacePrompts;
}
